import React from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import { useParams } from "react-router-dom";
// import ProductSlider from "./shop-components/product-slider-v1";
import SolarBatterySlider from "./shop-components/solar-battery-slider";
// import ProductDetails from "./shop-components/shop-details";
import SolarBatteryDetails from "./shop-components/solor-battery-details";
// import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";
import Neighbour from "./section-components/neighbour";
import Cateogory from "./section-components/category-v2";
import batteryData from "../data/batteryData";

const Solar_Battery = () => {
  const { id } = useParams();
  const battery = batteryData.find((item) => item.id === id);
  console.log(battery, "battery");

  if (!battery) {
    return (
      <div className="container text-center mt-5">
        <h2>Product Not Found</h2>
        <p>The requested battery does not exist.</p>
      </div>
    );
  }
  return (
    <div>
      <Navbar />
      <PageHeader
        headertitle={battery?.name}
        customclass="mb-0"
        Img="battery.webp"
      />
      <SolarBatterySlider />
      <SolarBatteryDetails battery={battery} />
      <Cateogory features={battery?.features} />
      {/* <Neighbour /> */}
      {/* <CallToActionV1 /> */}

      <Footer />
    </div>
  );
};

export default Solar_Battery;
